// Exports
export default {
	"moderationControlButtonContainer": "moderationControlButtonContainer_7QrwL"
};
